import { CLEAR_NEW_HISTORY, SET_NEW_HISTORY } from '@/store/mutation-types';
import { Commit } from 'vuex';
import { IHistoryOptions } from '@/types/chapter';

const initState: IHistoryOptions = {
  hasHistoryRecords: false
};

const actions = {
  setNewHistory(context: { commit: Commit; state: IHistoryOptions }, payload: boolean) {
    context.commit(SET_NEW_HISTORY, payload);
  }
};

const mutations = {
  [SET_NEW_HISTORY]: (state: IHistoryOptions, payload: boolean) => {
    state.hasHistoryRecords = payload;
  }
};

const getters = {
  hasHistoryRecords: (state: IHistoryOptions) => state.hasHistoryRecords
};

export default {
  state: initState,
  mutations,
  actions,
  getters
};
